import {Line} from 'vue-chartjs'
import {axios} from 'axios'
import { mapState } from 'vuex'
export default {
extends: Line,
props:{
    referenciaProductos: String
},
computed:{
    ...mapState(['costea'])
},
methods:{
    getProducts(){
        axios.get(`${this.costea.protocol}${localStorage.getItem('secret-word')}${this.costea.baseURL}productos`).then(res => {this.referenciaProductos = res.data; console.log(this.referenciaProductos)}).catch(error => {console.log(error)})
    }
},
data(){
    return{
        chartData:{
            labels: ['Codigo01', 'Codigo02', 'Codigo03', 'Codigo04', 'Codigo05'],
            datasets:[
                {
                    label:'Gastos de admon',
                    backgroundColor: '#00000000',
                    borderColor: "#003b99",
                    borderWidth: 2,
                    data: [300000,210000, 300000, 250000, 350000]
                },
                {
                    label:'Utilidad bruta',
                    backgroundColor: '#00000000',
                    borderColor: "#FF5f22",
                    borderWidth: 2,
                    data: [250000,150000, 220000, 180000, 200000]
                },
                {
                    label:'Precio de venta',
                    backgroundColor: '#00000000',
                    borderColor: "#5EDEE8",
                    borderWidth: 2,
                    data: [190000,180000, 270000, 120000, 320000]
                },
                {
                    label:'Costo total',
                    backgroundColor: '#00000000',
                    borderColor: "#FF9F33",
                    borderWidth: 2,
                    data: [150000,160000, 320000, 100000, 250000]
                }
            ]
        },
        options:{
            responsive:true,
            maintainAspectRatio:false,
            scales: {
                yAxes: [
                  {
                    ticks: {
                      beginAtZero: false,
                      padding: 5
                    }
                  }
                ],
              }
        }
    }
},
mounted(){
        this.renderChart(this.chartData, this.options)
        
    },
}